import http from '@merchstores/frontend/utils/http';
import { GET_MEMBER_CART_SUMMARY, APPLY_MEMBER_VOUCHERS } from '../routes';
import {
  IFetchMemberCartSummaryInput,
  IMemberCartSummary,
} from '@merchstores/frontend/types/members';
import {
  APPLY_MEMBER_VOUCHERS_TIMEOUT_MS,
  IMemberVouchersRequest,
  IMemberVouchersResult,
} from '@merchstores/frontend/utils/memberVouchers';

const fetchMemberCartSummary = async (
  params: IFetchMemberCartSummaryInput
): Promise<IMemberCartSummary> => {
  const result = await http.post(GET_MEMBER_CART_SUMMARY, params);
  return result.data;
};

const applyMemberVouchers = async (
  params: IMemberVouchersRequest
): Promise<IMemberVouchersResult> => {
  const result = await http.post(APPLY_MEMBER_VOUCHERS, params, {
    timeout: APPLY_MEMBER_VOUCHERS_TIMEOUT_MS,
  });
  return result.data;
};

export { fetchMemberCartSummary, applyMemberVouchers };
